<template id="app-new-website-popup">
  <div>
    <div v-if="showPopup" class="popupOverlay">
      <div class="popupCard">
        <div class="imageContainer">
          <div class="patientCard">
            <div class="patientImage">
              <img
                class="brainImage"
                src="/assets/image/newWebsitePopup/t1Brain.png"
              />
            </div>
            <div class="patientDetails">
              <div class="patientInfo">
                <div class="patientName">Liam Johnson</div>
                <div class="patientId">xqv9-7mnb-tz3</div>
              </div>
              <div class="patientMeta">
                <div class="metaLine">Elena Martell</div>
                <div class="metaLine">21/06/2025, 10:30</div>
              </div>
            </div>
          </div>
        </div>
        <div class="infoContainer">
          <div class="titleContainer">
            <img
              class="titleIcon"
              src="/assets/image/newWebsitePopup/starsIcon.svg"
            />
            <div class="title">New Lumi website available for testing</div>
          </div>
          <div class="description">
            <p>
              Try it out and share your feedback to help us shape the future of
              Lumi.
            </p>
            <p>
              You can easily switch back to the current website at any time.
            </p>
          </div>
          <div class="buttonRow">
            <button class="notNowButton" @click="dismiss()">Not now</button>
            <button class="tryButton" @click="tryNewWebsite()">
              <span>Try new website</span>
              <img
                class="arrowIcon"
                src="/assets/image/newWebsitePopup/arrowRight.svg"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="showMiniAlert" class="miniAlert">
      <button class="miniCloseButton" @click="dismissMini()">
        <img
          class="miniCloseIcon"
          src="/assets/image/newWebsitePopup/closeIcon.svg"
        />
      </button>
      <div class="miniTitle">New Lumi website available</div>
      <button class="tryButton miniTryButton" @click="tryNewWebsite()">
        <span>Try new website</span>
        <img
          class="arrowIcon"
          src="/assets/image/newWebsitePopup/arrowRight.svg"
        />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import appSettings from "./appSettings";
import featureToggles from "../enums/FeatureToggles.js";

const INTRO_SHOWN_KEY = "newWebsiteIntroShown";
const MINI_ALERT_DISMISSED_KEY = "newWebsiteAlertDismissed";

export default {
  name: "AppNewWebsitePopup",
  data: () => ({
    introShown: !!window.localStorage[INTRO_SHOWN_KEY],
    miniAlertDismissed: !!window.sessionStorage[MINI_ALERT_DISMISSED_KEY],
  }),
  computed: {
    ...mapState(["allowedFeatureToggles"]),
    hasPreviewToggle() {
      return this.allowedFeatureToggles.includes(
        featureToggles.WEBSITE_PREVIEW
      );
    },
    showPopup() {
      return this.hasPreviewToggle && !this.introShown;
    },
    showMiniAlert() {
      return (
        this.hasPreviewToggle && this.introShown && !this.miniAlertDismissed
      );
    },
    previewUrl() {
      const host = appSettings.host.replace(/^old\./, "");
      return `https://${host === "lumi.cloud" ? "www.lumi.cloud" : host}`;
    },
  },
  methods: {
    markAsShown() {
      window.localStorage[INTRO_SHOWN_KEY] = Date.now();
      this.introShown = true;
    },
    dismiss() {
      this.markAsShown();
    },
    dismissMini() {
      window.sessionStorage[MINI_ALERT_DISMISSED_KEY] = Date.now();
      this.miniAlertDismissed = true;
    },
    tryNewWebsite() {
      this.markAsShown();
      window.location.href = this.previewUrl;
    },
  },
};
</script>

<style scoped>
.popupOverlay {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
}

.popupCard {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  padding: 24px;
  background: #01141a;
  border: 1px solid #0a2c36;
  border-radius: 8px;
}

.imageContainer {
  position: relative;
  width: 300px;
  height: 300px;
  flex-shrink: 0;
  background: #032129;
  border: 1px solid #0a2c36;
  border-radius: 4px;
}

.patientCard {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  width: 219px;
  padding: 4px;
  background: #0a2c36;
  border-radius: 8px;
  overflow: hidden;
}

.patientImage {
  position: relative;
  width: 100%;
  aspect-ratio: 238 / 134;
  background: black;
  border-radius: 4px;
  overflow: hidden;
}

.brainImage {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 98.5%;
}

.patientDetails {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  padding: 16px 12px 12px 12px;
  text-align: left;
}

.patientInfo {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.patientName {
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  color: #fcfdfd;
}

.patientId {
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #bad6de;
}

.patientMeta {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
}

.metaLine {
  color: #7aaab8;
}

.infoContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  width: 300px;
  flex-shrink: 0;
}

.titleContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.titleIcon {
  width: 32px;
  height: 32px;
}

.title {
  width: 228px;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  color: #fcfdfd;
}

.description {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  color: #bad6de;
}

.description p {
  margin: 0;
}

.description p + p {
  margin-top: 20px;
}

.buttonRow {
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
}

.notNowButton,
.tryButton {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 10px 12px;
  border-radius: 4px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  color: #fcfdfd;
  cursor: pointer;
}

.notNowButton {
  background: transparent;
  border: 1px solid #0a2c36;
}

.notNowButton:hover {
  background: #032129;
}

.tryButton {
  flex: 1;
  background: #2d6b7d;
  border: none;
}

.tryButton:hover {
  background: #337789;
}

.arrowIcon {
  width: 20px;
  height: 20px;
}

.miniAlert {
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 16px;
  background: #032129;
  border: 1px solid #0a2c36;
  border-radius: 8px;
  filter: drop-shadow(0px 4px 5px rgba(0, 6, 8, 0.4));
}

.miniCloseButton {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 10px;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.miniCloseButton:hover {
  background: #0a2c36;
}

.miniCloseIcon {
  width: 20px;
  height: 20px;
}

.miniTitle {
  width: 166px;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
  color: #fcfdfd;
}

.miniTryButton {
  width: 100%;
}
</style>
